import clsx from 'clsx';
import { ButtonColor, ButtonVariant, Icon, IconButton, Typography, TypographyType } from '../../../../components';
import { Alignment, ComponentSize } from '../../../../types';

interface HoverableContentProps {
  content: string | React.ReactNode;
  icon: Icon;
  tooltip: string;
  onClick: () => void;
  disabled?: boolean;
  // Controlled state that overrides the default hover behavior.
  // Used for when the content is not a string.
  showButton?: boolean;
}

const HoverableContent = ({ content, icon, tooltip, onClick, disabled, showButton = false }: HoverableContentProps) => {
  return (
    <div className="group relative flex items-start">
      {typeof content === 'string' && (
        <Typography alignment={Alignment.RIGHT} type={TypographyType.X_SMALL}>
          {content}
        </Typography>
      )}
      {typeof content !== 'string' && content}
      {!disabled && (
        <div
          className={clsx(content && !showButton ? 'invisible absolute -top-1 right-0 group-hover:visible' : '-mt-1')}
        >
          <IconButton
            color={ButtonColor.NEUTRAL}
            variant={ButtonVariant.SOFT}
            icon={icon}
            size={ComponentSize.X_SMALL}
            tooltip={tooltip}
            onClick={onClick}
          />
        </div>
      )}
    </div>
  );
};

export default HoverableContent;
